module.exports = __webpack_public_path__ + "static/media/Mahesh Bhusanoor.53ef6c5f.jpg";